import React, { PureComponent, ReactNode } from 'react'
import { DispatchProp } from 'react-redux'
import { connectRedux } from '../../../helpers/connectRedux'
import { RouteComponentProps, withRouter } from '../../../helpers/withRouter'

import { IServiceInfo, IStop } from '../../../models'
import { setBusStopAction, setShowSingleStopModalAction, setSingleBusStopDirectionAction } from '../../../store/actions'
import { dispatchPick } from '../../../store/guest-guard'
import { IStoreState } from '../../../store/states'
import { ServiceLine } from './ServiceLine'
import StyledSection from './styles'
import { appsStyleSelected } from '../../../helpers/app'
import { urls } from '../../../routing'
import { AnyAction } from 'redux'

interface IProps extends DispatchProp<AnyAction>, RouteComponentProps {
  serviceInfos: IServiceInfo[]
  pickedServiceInfo: number | null
  pickedOriginBusStop?: IStop
  destinationBusStops: IStop[]
  pickedDestinationBusStop?: IStop
  onRequestNavigateToDate?: () => void
}

class ListStopsView extends PureComponent<IProps> {
  private get servicesSorted(): ReactNode {
    const { destinationBusStops, pickedServiceInfo, pickedOriginBusStop, pickedDestinationBusStop, serviceInfos } = this.props
    return serviceInfos
      .sort((a, b) => ('' + a.name).localeCompare(b.name))
      .map(serviceInfo => (
        <ServiceLine
          key={ `${serviceInfo.id}` }
          onClickStop={ (stop) => this.onClickStop(stop, serviceInfo) }
          serviceInfo={ serviceInfo }
          destinationBusStops={ destinationBusStops }
          pickedServiceInfo={ pickedServiceInfo }
          pickedOriginBusStop={ pickedOriginBusStop }
          pickedDestinationBusStop={ pickedDestinationBusStop }
          moreThanOneServiceInfo={ serviceInfos.length > 1 }
        />
      ))
  }
  public render(): ReactNode {
    return (
      <StyledSection className={`${appsStyleSelected?.style}`}>
        { this.servicesSorted }
      </StyledSection>
    )
  }

  private onClickStop = (stop: IStop, serviceInfo: IServiceInfo) => {
    const { dispatch, history, onRequestNavigateToDate } = this.props

    if (serviceInfo.singleStopReservations) {
      if (serviceInfo.roundTrips) {
        if (!dispatchPick(dispatch, setSingleBusStopDirectionAction(true, { ...stop, serviceInfo }))) return
        if (onRequestNavigateToDate) {
          onRequestNavigateToDate()
        } else {
          const name = new URLSearchParams(location.search).get('name') ?? history.location.state?.name
          const lastName = new URLSearchParams(location.search).get('lastName') ?? history.location.state?.lastName
          const email = new URLSearchParams(location.search).get('email') ?? history.location.state?.email
          const townId = new URLSearchParams(location.search).get('townId') ?? history.location.state?.townId

          history.push(urls.newReservationDateStep, {
            userData: { name, lastName, email },
            townId
          })
        }
      } else {
        dispatch(setShowSingleStopModalAction(true, { ...stop, serviceInfo }))
      }
    }
    else dispatch(setBusStopAction({ stop: { ...stop, serviceInfo } }))
  }
}

const mapStateToProps = ({ newReservation }: IStoreState) => ({
  serviceInfos: newReservation.serviceInfos,
  pickedOriginBusStop: newReservation.pickedOriginBusStop,
  destinationBusStops: newReservation.destinationBusStops,
  pickedDestinationBusStop: newReservation.pickedDestinationBusStop,
  pickedServiceInfo: newReservation.pickedServiceInfo
})

export default withRouter(connectRedux(mapStateToProps, ListStopsView as any))
